export enum ClientBookingSelectAction {
  CONTINUE = 'continue',
  PROCEED = 'proceed',
}
